import { render } from "./PaymentAcknowledgementModal.vue?vue&type=template&id=1b6a3c07"
import script from "./PaymentAcknowledgementModal.vue?vue&type=script&lang=js"
export * from "./PaymentAcknowledgementModal.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__